import * as yup from "yup";

export const novaSenhaSchema = yup.object().shape({
    novaSenha: yup.string()
      .required('Nova senha é obrigatória')
      .min(6, 'A nova senha deve ter pelo menos 6 caracteres'),
    confirmacaoSenha: yup.string()
      .oneOf([yup.ref('novaSenha'), undefined], 'As senhas não correspondem')
      .required('Confirme a nova senha')
});